import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const srOnlyFn = /* @__PURE__ */ createRecipe('sr-only', {}, [])

const srOnlyVariantMap = {}

const srOnlyVariantKeys = Object.keys(srOnlyVariantMap)

export const srOnly = /* @__PURE__ */ Object.assign(memo(srOnlyFn.recipeFn), {
  __recipe__: true,
  __name__: 'srOnly',
  __getCompoundVariantCss__: srOnlyFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: srOnlyVariantKeys,
  variantMap: srOnlyVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, srOnlyVariantKeys)
  },
  getVariantProps: srOnlyFn.getVariantProps,
})